import React, { useState, useEffect } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { toPercent, addCommas } from './../../addComas'
import { db } from './../../Firebase'





function Turismo() {

    //Cargar datos

    const [Ext, setExt] = useState(null)
    const [Cru, setCru] = useState(null)
    const [Col, setCol] = useState(null)
    const [Ven, setVen] = useState(null)
    const [Viajeros, setViajeros] = useState(null)
    const [fecha, setFecha] = useState(null)


    //Get DATA from firebase
    useEffect(() => {
        db.collection('Pruebas').doc('TUR')
            .collection('Extranjeros no Residentes').doc('data')
            .onSnapshot(snapshot => {
                setExt(snapshot.data())
            });
        db.collection('Pruebas').doc('TUR')
            .collection('Cruceristas').doc('data')
            .onSnapshot(snapshot => {
                setCru(snapshot.data())
            });
        db.collection('Pruebas').doc('TUR')
            .collection('Colombianos Residentes en el Exterior').doc('data')
            .onSnapshot(snapshot => {
                setCol(snapshot.data())
            });

        db.collection('Pruebas').doc('TUR')
            .collection('Estimación de Venezolanos').doc('data')
            .onSnapshot(snapshot => {
                setVen(snapshot.data())
            });
        db.collection('Pruebas').doc('TUR')
            .collection('Viajeros').doc('data')
            .onSnapshot(snapshot => {
                setViajeros(snapshot.data())
            });
        //Cargar fecha actualización
        db.collection('Pruebas').doc('TUR')
            .onSnapshot(snapshot => {
                setFecha(snapshot.data()['Fecha'])
            });


    }, [])


    return (
        <TableContainer component={Paper}>
            <Table aria-label="a dense table">
                <TableHead>
                    {Ext && (
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align='center' style={{ fontWeight: 700 }}>
                                Valor {fecha && fecha}
                            </TableCell>
                            <TableCell align='center' style={{ fontWeight: 700 }}>
                                Crecimiento {fecha && fecha}
                            </TableCell>

                        </TableRow>
                    )}
                </TableHead>
                <TableBody>
                    {Ext && (
                        <TableRow>

                            <TableCell component="th" scope="row">Extranjeros no Residentes</TableCell>
                            <TableCell align="center">{addCommas(Ext['Valor'])}</TableCell>
                            <TableCell align="center">{toPercent(Ext['Crecimiento'])}</TableCell>

                        </TableRow>
                    )}
                    {Col && (
                        <TableRow>

                            <TableCell component="th" scope="row">Colombianos Residentes en el Exterior</TableCell>
                            <TableCell align="center">{addCommas(Col['Valor'])}</TableCell>
                            <TableCell align="center">{toPercent(Col['Crecimiento'])}</TableCell>

                        </TableRow>
                    )}
                    {Cru && (
                        <TableRow>

                            <TableCell component="th" scope="row">Cruceristas</TableCell>
                            <TableCell align="center">{addCommas(Cru['Valor'])}</TableCell>
                            <TableCell align="center">{toPercent(Cru['Crecimiento'])}</TableCell>

                        </TableRow>
                    )}
                    {Ven && (
                        <TableRow>

                            <TableCell component="th" scope="row">Estimación de Venezolanos</TableCell>
                            <TableCell align="center">{addCommas(Ven['Valor'])}</TableCell>
                            <TableCell align="center">{toPercent(Ven['Crecimiento'])}</TableCell>

                        </TableRow>
                    )}
                    {Viajeros && (
                        <TableRow>

                            <TableCell component="th" scope="row" style={{ fontWeight: 700 }}>Viajeros</TableCell>
                            <TableCell align="center" style={{ fontWeight: 700 }}>{addCommas(Viajeros['Valor'])}</TableCell>
                            <TableCell align="center" style={{ fontWeight: 700 }}>{toPercent(Viajeros['Crecimiento'])}</TableCell>

                        </TableRow>
                    )}

                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default Turismo
